export enum AvailabilitySearchType {
  default = 0,
  allotment = 1,
  fixedDuration = 2,
  flight = 3,
}
